import { Check } from 'lucide-react';
import { labelClass } from '@/shared/ui/formClasses';

const CHOICE =
  'flex min-h-9 items-center justify-between gap-3 rounded-lg border px-3 py-2 text-left text-sm transition-colors duration-150 focus-visible:focus-ring';
const SELECTED = `${CHOICE} border-brand bg-default text-brand`;
const IDLE = `${CHOICE} border-default bg-default text-muted hover:border-hover hover:text-strong`;

/** Un gruppo di scelte a pulsante con il suo aiuto: `selected` è un valore o, se multipla, una lista. */
export default function ChoiceGroup({ id, label, hint, options, selected, onChoose, error }) {
  const isSelected = (value) =>
    Array.isArray(selected) ? selected.includes(value) : selected === value;
  const describedBy = error ? `${id}-hint ${id}-error` : `${id}-hint`;

  return (
    <div id={id} role="group" aria-labelledby={`${id}-label`} aria-describedby={describedBy}>
      <p id={`${id}-label`} className={labelClass}>
        {label}
        <span aria-hidden> *</span>
      </p>
      <div className="mt-1 grid gap-2 sm:grid-cols-2">
        {options.map(({ value, label: optionLabel }) => (
          <button
            key={value}
            type="button"
            aria-pressed={isSelected(value)}
            onClick={() => onChoose(value)}
            className={isSelected(value) ? SELECTED : IDLE}
          >
            <span>{optionLabel}</span>
            {isSelected(value) && <Check aria-hidden className="size-4 shrink-0 text-brand" />}
          </button>
        ))}
      </div>
      <p id={`${id}-hint`} className="mt-1 text-caption text-subtle">
        {hint}
      </p>
      {error && (
        <p id={`${id}-error`} className="mt-1 text-caption text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
